export default __webpack_public_path__ + "static/media/index_circle.dd8582e3.webp";